export const KeenSliderNavigation = (options = {}) => {
  return (slider) => {
    let wrapper = options.wrapper;
    let dots, arrowLeft, arrowRight;
    let dragged = false;

    function markup(remove) {
      wrapperMarkup(remove);
      dotMarkup(remove);
      arrowMarkup(remove);
    }

    function removeElement(element) {
      element && element.parentNode && element.parentNode.removeChild(element);
    }

    function createDiv(className) {
      const div = document.createElement("div");
      const classNames = className.split(" ");
      classNames.forEach((name) => div.classList.add(name));
      return div;
    }

    function arrowMarkup(remove) {
      if (remove) {
        const stored = slider._keenNavArrows;
        if (stored) {
          removeElement(stored.left);
          removeElement(stored.right);
          delete slider._keenNavArrows;
        } else {
          removeElement(arrowLeft);
          removeElement(arrowRight);
        }
        arrowLeft = undefined;
        arrowRight = undefined;
        return;
      }

      if (!options.arrows) {
        return;
      }

      const root = slider.container;
      arrowLeft =
        root.querySelector(":scope > [data-arrow-left]") ||
        root.querySelector("[data-arrow-left]");
      arrowRight =
        root.querySelector(":scope > [data-arrow-right]") ||
        root.querySelector("[data-arrow-right]");

      if (!arrowRight || !arrowLeft) {
        return;
      }

      slider._keenNavArrows = { left: arrowLeft, right: arrowRight };

      const onPrev = (e) => {
        e.preventDefault();
        e.stopPropagation();
        slider.prev();
      };
      const onNext = (e) => {
        e.preventDefault();
        e.stopPropagation();
        slider.next();
      };
      arrowLeft.addEventListener("click", onPrev);
      arrowRight.addEventListener("click", onNext);
    }

    function wrapperMarkup(remove) {
      if (remove) {
        const parent = wrapper.parentNode;
        while (wrapper.firstChild)
          parent.insertBefore(wrapper.firstChild, wrapper);
        removeElement(wrapper);
        return;
      }
      if (!options.wrapper) {
        wrapper = createDiv(
          `keen-slider__navigation-wrapper keen-slider__slide-active-${slider.track.details.rel}`
        );
        slider.container.parentNode.appendChild(wrapper);
        wrapper.appendChild(slider.container);
      }
    }

    function dotMarkup(remove) {
      if (remove) {
        removeElement(dots);
        return;
      }

      if (!options.dots) {
        return;
      }

      let slidesPerView = 1;
      if (slider.options?.slides && slider.options?.slides.perView) {
        slidesPerView = slider.options?.slides.perView;
      }

      if (slider.track?.details?.slides.length <= slidesPerView) {
        return;
      }

      if (!options.dots) return;
      const initialButton = options.dots.querySelector("[data-dot-button]");
      options.dots.innerHTML = "";

      slider.track?.details?.slides.forEach((_e, idx) => {
        const newDot = initialButton?.cloneNode(true);
        const newDotInner = newDot.querySelector('[data-dot]');
        newDot.onclick = () => {
          slider.moveToIdx(idx);
        };
        // newDot.ariaLabel = `Navigate to slide ${idx + 1}`;
        if (newDotInner) newDotInner.ariaLabel = `Navigate to slide ${idx + 1}`;
        options.dots.appendChild(newDot);
      });
      options.dots.setAttribute("data-active", "true");
    }

    function updateClasses() {
      const slide = slider.track?.details?.rel;
      if (isNaN(slide)) return;
      const nav = slider._keenNavArrows;
      const leftBtn = nav?.left ?? arrowLeft;
      const rightBtn = nav?.right ?? arrowRight;
      if (leftBtn && rightBtn) {
        slide === 0
          ? leftBtn.classList.add("arrow--disabled")
          : leftBtn.classList.remove("arrow--disabled");
        slide === slider.track.details.slides.length - 1
          ? rightBtn.classList.add("arrow--disabled")
          : rightBtn.classList.remove("arrow--disabled");
      }
      if (options?.arrows) {
        const activeCan = slider?.slides[slide];
        slider?.slides.forEach((slide) => {
          slide.ariaCurrent = activeCan === slide;
        });
      }
      if (options.dots) {
        Array.from(options.dots.children).forEach(function (dot, idx) {
          const dotEl = dot.querySelector("[data-dot]");
          if (idx === slide) {
            dot.classList.add("dot--active");
            // dotEl.ariaSelected = true;
            slider.slides[idx].ariaHidden = false;
          } else {
            dot.classList.remove("dot--active");
            // dotEl.ariaSelected = false;
            slider.slides[idx].ariaHidden = true;
          }
        });
      }
      if (wrapper) {
        wrapper.className = wrapper.className.replace(
          /\b(keen-slider__slide-active-[^\s]+)\b/,
          `keen-slider__slide-active-${slide}`
        );
      }
    }

    slider.on("created", () => {
      markup();
      updateClasses();
    });
    slider.on("optionsChanged", () => {
      if (!options.arrows) {
        markup(true);
        markup();
      }
      updateClasses();
    });
    slider.on("dragStarted", () => { dragged = true; });
    slider.on("dragEnded", () => {
      setTimeout(() => {
        const active = document.activeElement;
        if (active && slider.slides.includes(active)) {
          active.blur();
        }
        dragged = false;
      }, 700);
    });
    slider.on("slideChanged", () => {
      updateClasses();
      const activeSlide = slider.slides[slider.track.details.rel];
      activeSlide.setAttribute("tabindex", "-1");
      if (dragged) {
        if (document.activeElement === activeSlide) {
          activeSlide.blur();
        }
        return;
      }
      activeSlide.focus();
    });
    slider.on("destroyed", () => {
      markup(true);
    });
  };
};
